// BUG-2485: Manage Pre-Order cancelled-order classification.
//
// A pre-order can end up cancelled in two different ways, and both must leave the
// main Manage Pre-Order list and show only in the "Cancelled" tab:
//  1. "CAN" — cancelled via Manage Pre-Order "Cancel Order" (cancelPreorder mutation)
//     or Backoffice. The original order is flagged docstatus "CAN" and keeps its
//     original qty/value.
//  2. "CART" — the cashier cancelled the cart on the Pre-Order screen
//     (usePreorderHandlers.clearCartData). That posts a NEW zero-valued order with
//     docstatus "CO" and layAway "Y", so it lands in the layaway list as Qty 0 / Total 0.
//     Only "CO" counts: Backoffice drafts ("DR", documentno "New", no till) are also
//     zero-valued and reach the list on a global search, but they are not cancels.

export const PREORDER_TABS = { ACTIVE: "All Orders", CANCELLED: "Cancelled" };

export const CANCEL_TYPE = { CAN: "CAN", CART: "CART" };

const isZero = (value) => value !== null && value !== undefined && value !== "" && Number(value) === 0;

export const getPreorderCancelType = (order) => {
  if (!order) return null;
  if (order.docstatus === "CAN") return CANCEL_TYPE.CAN;
  if (order.docstatus === "CO" && isZero(order.total) && isZero(order.totalQty ?? 0)) return CANCEL_TYPE.CART;
  return null;
};

export const isCancelledPreorder = (order) => getPreorderCancelType(order) !== null;

// Tags each row with type ("Cancelled" / "Layaway") and cancelType so the card/table
// render and the action gates read one classification.
export const classifyPreorders = (orders = []) =>
  orders.map((order) => {
    const cancelType = getPreorderCancelType(order);
    return { ...order, type: cancelType ? "Cancelled" : "Layaway", cancelType };
  });

export const filterPreordersByTab = (orders = [], tab) => orders.filter((order) => (tab === PREORDER_TABS.CANCELLED ? isCancelledPreorder(order) : !isCancelledPreorder(order)));
